<script setup lang="ts">
import type { components as ContentSchemas } from '@core/types/content-shapes'
import type { BlogPostListItem } from '@core/types/blog'
import { useCoreConfig, useHead, useI18n, useSeoMeta, useContentSeo } from '#imports'

export interface PageBlogProps {
    pageData?: ContentSchemas['schemas']['Page'] | null
    posts: BlogPostListItem[]
}

const props = defineProps<PageBlogProps>()

const { t } = useI18n()
const { site } = useCoreConfig()

const { getHead, getSeoMeta } = useContentSeo(
    props.pageData?.seo || {
        metaTitle: t('core.components.PageBlog.metaTitle', { site: site.name }),
        metaDescription: t('core.components.PageBlog.metaDescription', { site: site.name }),
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
</script>

<template>
    <NimbusBlogApp
        title="Blog"
        :subtitle="t('core.components.PageBlog.subtitle', { site: site.name })"
        :search-field-placeholder="t('core.components.PageBlog.searchPlaceholder')"
        :error-options="{
            noSearchResultText: t('core.components.PageBlog.noSearchResult'),
            noBlogsText: t('core.components.PageBlog.noBlogs')
        }"
        :posts="props.posts"
    />
</template>
